import { ArrowRight } from "lucide-react";
import { Link } from "react-router";
import { ArticleCard } from "@client/components/blog/ArticleCard";
import { buttonClassName } from "@client/components/ui/button-variants";
import { SectionHeading } from "@client/components/ui/SectionHeading";
import { CardGridSkeleton } from "@client/components/ui/StateMessages";
import { useLatestArticles } from "@client/hooks/use-catalog";
import { blogCopy } from "@client/locales/id/blog";

export function LatestArticlesSection() {
  const { data: articles, isPending } = useLatestArticles();
  if (!isPending && (!articles || articles.length === 0)) return null;

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 md:py-24">
      <SectionHeading
        eyebrow={blogCopy.latestEyebrow}
        title={blogCopy.latestTitle}
        action={
          <Link to="/blog" className={buttonClassName("ghost", "md", "group self-start md:self-auto")}>
            {blogCopy.viewAll}
            <ArrowRight className="size-4 transition-transform duration-200 ease-expo-out group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
        }
      />
      <div className="mt-10">
        {isPending ? (
          <CardGridSkeleton count={3} />
        ) : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {articles?.map((article) => <ArticleCard key={article.id} article={article} />)}
          </div>
        )}
      </div>
    </section>
  );
}
